import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LoginModal from "./components/login-modal.vue";
import RegistrationModal from "./components/registration-modal.vue";
import NotificationPopup from "./components/account-notification.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'user-account',
  emits: ["loader"],
  setup(__props) {

 // console.log warning issue

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LoginModal),
    _createVNode(RegistrationModal),
    _createVNode(NotificationPopup)
  ], 64))
}
}

})